const WEBSITE_URL = process.env.REACT_APP_API_URL;

// Action Creators

export async function fetchPhotoUrls() {
  const request = await fetch(`${WEBSITE_URL}/images`);
  const result = await request.json();
  return result;
}



// WEBPACK FOOTER //
// ./src/actions/photos.js